import http from '../utils/http';
import axios from 'axios';
import i18n from '@/main';

const baseRoute = '/operacao/laudo';

export default {
    buscarPorId(idLaudo) {
        return http.get({
            url: baseRoute + `/${idLaudo}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoesDeFiscalizacaoDaOperacao')
        });
    },

    buscar(payload) {
        return http.post({
            url: baseRoute,
            data: payload,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoFiscalizacaoDeOperacoes')
        });
    },

    inserir(body) {
        return http.post({
            url: baseRoute + '/inserir',
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.solicitandoFiscalizacao')
        });
    },

    cancelar(id, body) {
        return http.post({
            url: baseRoute + `/${id}/cancelar`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.cancelandoFiscalizacao')
        });
    },

    gerarShapeFile(id) {
        const fileLink = document.createElement('a');
        return http
            .get({
                url: baseRoute + `/${id}/gerar-shape`,
                responseType: 'blob',
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.preparandoShapeParaDownload')
            })
            .then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    fileLink.href = fileURL;
                    const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    return Promise.resolve();
                }
            })
            .catch(error => {
                return Promise.reject(error);
            })
            .finally(() => {
                fileLink.remove();
            });
    },

    baixarShapeEmLote(payload) {
        const fileLink = document.createElement('a');
        return http
            .post({
                url: baseRoute + `/gerar-shape-em-lote`,
                responseType: 'blob',
                lockScreen: true,
                data: payload,
                lockMessage: 'Preparando dados para download'
            })
            .then(response => {
                if (response.status === 200) {
                    const fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    fileLink.href = fileURL;
                    const filenameRegex = /filename=['"]?([^;\r\n"']*)['"]?;?/;
                    const contentDisposition =
                        response.headers['content-disposition'];

                    fileLink.setAttribute(
                        'download',
                        filenameRegex.exec(contentDisposition)[1]
                    );
                    document.body.appendChild(fileLink);

                    fileLink.click();
                    return Promise.resolve();
                }
            })
            .catch(error => {
                return Promise.reject(error);
            })
            .finally(() => {
                fileLink.remove();
            });
    },

    gerarExcel(payload) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: baseRoute + `/gerar-excel`,
                    responseType: 'blob',
                    lockScreen: true,
                    data: payload,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    inserirResultado(input) {
        const formData = new FormData();

        const url =
            process.env.VUE_APP_HTTP_PATH + '/operacao/laudo/inserir-resultado';

        formData.append('id', input.id);
        formData.append('status', input.status);
        formData.append('file', input.arquivo);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    validarPlanilha(planilha) {
        const url =
            process.env.VUE_APP_HTTP_PATH + '/operacao/laudo/validar-planilha';

        const formData = new FormData();
        formData.append('file', planilha.raw);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    downloadResultado(id) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${id}/download-resultado`,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoResultadoDoLaudoParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;

                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    downloadResultadoLote(body) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: baseRoute + `/download-lote`,
                    responseType: 'blob',
                    data: body,
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },
    downloadPlanilhaErro(arquivoHash) {
        const fileLink = document.createElement('a');
        try {
            return http
                .get({
                    url: baseRoute + `/${arquivoHash}/download-planilha`,
                    responseType: 'blob',
                    data: null,
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },
    processarPlaninlha(arquivoHash) {
        return http.post({
            url: baseRoute + `/${arquivoHash}/processar-planilha`,
            data: null,
            lockScreen: true
        });
    }
};
